import React from "react";

export default function HeaderStats() {
  return (
    <>
      <div className="relative bg-lightBlue-600 md:pt-28 pb-32 pt-12">
        <div className="px-4 md:px-10 mx-auto w-full">
        </div>
      </div>
    </>
  );
}
